import React from "react";
import { SEO, MainLayout, CustomerType } from "../../../components";

const CustomerTypePage = () => {
  return (
    <>
      <SEO title="Customer Type" />
      <MainLayout>
        <CustomerType />
      </MainLayout>
    </>
  );
};

export default CustomerTypePage;
